import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseSelector } from "../../rawData/warehouse/warehouseSelector";
import { WarehouseLocationDeclarationViewModel, location } from "./warehouseLocationDeclaration-viewModel"

export class WarehouseLocationDeclarationView extends View<WarehouseLocationDeclarationViewModel>{
    GetViewUniqueId(): string {
        return "V-52D97C47-20A5-45F2-B301-45720E8A5F12"
    }
    loadHtml(): string {
        let element = require('./warehouseLocationDeclaration.html').default;
        let style = require('./warehouseLocationDeclaration.less');
        return element;
    }
    constructor() {
       super();
    }
    public set warehouseSelector(v: WarehouseSelector) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelector { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelector;
    public set locations(v: ObservableArray<location>) { this._locations = v; } public get locations(): ObservableArray<location> { return this._locations;} private _locations: ObservableArray<location>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }
}
